import Card from "./Card/Card";

const MoreFeatures = () => {
  return (
    <div className="features-container" id="more-features">
      <div className="more-features">
        <h1 className="features-title" data-aos="fade-up" data-aos-delay="100">
          Stay on the Cutting Edge
        </h1>
        <p
          className="features-description"
          data-aos="fade-up-right"
          data-aos-delay="150"
        >
          Enjoy first-class support for Ruby 2.x and Rails 6.x, Sinatra, React,
          Angular, Puppet, Docker, and more.
        </p>
        <button
          className="features-btn"
          data-aos="fade-up-left"
          data-aos-delay="200"
        >
          SEE ALL FEATURES
        </button>
      </div>
      <Card />
    </div>
  );
};

export default MoreFeatures;
